"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchMerchantContractsInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_hook_form_1 = require("react-hook-form");
const mui_inputs_entity_1 = require("@dzambalaorg/mui-inputs-entity");
const react_hooks_1 = require("@dzambalaorg/react-hooks");
const SearchMerchantContractsInput = (props) => {
    const { name, fetchData, withTokenType = false, ...rest } = props;
    const form = (0, react_hook_form_1.useFormContext)();
    const merchantId = (0, react_hook_form_1.useWatch)({ name: "merchantId" });
    const tokenType = (0, react_hook_form_1.useWatch)({ name: "tokenType" });
    (0, react_hooks_1.useDidMountEffect)(() => {
        form.setValue(name, [], { shouldDirty: true, shouldTouch: true });
    }, [merchantId]);
    return ((0, jsx_runtime_1.jsx)(mui_inputs_entity_1.EntityInput, { name: name, controller: "contracts", fetchData: {
            ...fetchData,
            ...(withTokenType ? { contractType: [tokenType] } : {}),
            merchantId,
        }, ...rest }));
};
exports.SearchMerchantContractsInput = SearchMerchantContractsInput;
//# sourceMappingURL=index.js.map